import { SpecialistInfo } from '@/modules/JobPointOfContact/specialistInfo';
import Image from 'next/image';

import styles from './JobContactSpecialist.module.scss';

type JobContactSpecialistProps = SpecialistInfo & {
  jobNumber: string;
};

export const JobContactSpecialist = ({
  jobNumber,
  name,
  role,
  phone,
  email,
  image,
}: JobContactSpecialistProps) => (
  <div className={styles.jobContactSpecialist}>
    <h2 className={styles.title}>Get in touch with:</h2>

    <div className={styles.contentContainer}>
      <div className={styles.imageContainer}>
        <Image src={image} priority={true} alt={`Portrait of ${name}, ${role}`} />
      </div>
      <div className={styles.textContainer}>
        <div>
          <p className={styles.name}>
            <strong>{name}</strong>
          </p>
          <p className={styles.role}>{role}</p>
        </div>
        <div className={styles.contactDetails}>
          <p>
            <a href={`tel:${phone}`}>{phone}</a>
          </p>
          <p className={styles.email}>
            <a href={`mailto:${email}`}>{email}</a>
          </p>
        </div>
      </div>
    </div>
    <p className={styles.jobReference}>
      Please quote job reference: <strong>{jobNumber}</strong>
    </p>
  </div>
);
